import { put } from "../../service/api";

const ChangeMerchantPassword = async (merchantId, body) => {
  try {
    return await put(`/merchant/${merchantId}/password`, body);
  } catch (error) {
    console.error("Error ChangeMerchantPassword:", error);
    throw error;
  }
};

export default ChangeMerchantPassword;
